// extracted by mini-css-extract-plugin
var _1 = "_physicalGoldTable-module__container";
var _2 = "_physicalGoldTable-module__table-container";
var _3 = "_physicalGoldTable-module__title";
export { _1 as "container", _2 as "table-container", _3 as "title" }
